/* eslint-disable */
import React from 'react';
// import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function ExecutiveBanner() {
    
    return (
        <>

            <div className="banner">
            <img
                src='../../assets/images/executive.jpg'
                 alt="Executive Assistant and Market Research Services - ConnectMyVA"
                    title="Professional Executive Support for Businesses - ConnectMyVA"
                className="bannerImage"
            />
        </div>
            

        </>
    )
}

export default ExecutiveBanner
